import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setMaterialsAgentTutorialFinished, showMaterialsAgentTutorial} from "../../actions/tutorialFunctions";
import WithPingPilotCheck from "../look/hocs/withPingPilotCheck";

const PingPilotButton = (props) => {

  const {design, showMaterialsAgentTutorial, setMaterialsAgentTutorialFinished, materialsAgentTutorialIsOpened,
    materialsAgentTutorialFinished, pingButton} = props;

  const pingButtonClick = () => {
    pingButton.click();
    if (materialsAgentTutorialIsOpened) {
      showMaterialsAgentTutorial(false);
    }
    if (!materialsAgentTutorialFinished) {
      setMaterialsAgentTutorialFinished(true);
    }
  }

  if (design === "mainButton") {
    return (
      <button className="mobilebutton mobilebutton--co-browse" onClick={pingButtonClick}>
        <span className="mobilebutton-text">Help</span>
      </button>
    )
  }

  return (
    <button className="selection-main__image-button omnibrowse-code-button" onClick={pingButtonClick} />
  )
};

PingPilotButton.propTypes = {
  design: PropTypes.string
}

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {materialsAgentTutorialIsOpened, materialsAgentTutorialFinished} = store.tutorialState;
  return {
    visualizersLoadedLength: visualizersLoaded.length,
    materialsAgentTutorialIsOpened,
    materialsAgentTutorialFinished,
  };
};

const mapDispatchToProps = {
  showMaterialsAgentTutorial,
  setMaterialsAgentTutorialFinished,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithPingPilotCheck(PingPilotButton))

